export default {
  computed: {
    saleIsUnconditional() {
      return this.form.saleUnconditional.values
        && this.form.saleUnconditional.values.select === 'yes';
    },
  },
  methods: {
    onSaleUnconditionalInput(values) {
      this.onInput(values);
      this.form.unconditionalDate.isHidden = !this.saleIsUnconditional;
    },
  },
};
